
/**处理工单 */
export default class ProcessWorkOrderPO {
    /**工单Id */
    workId:number;
    /**操作人 */
    operater:string;
    /**操作时间 */
    operateTime:Date;
    /**操作步骤 */
    actionId:number;
    /**处理结束时间 */
    processTime:Date;
    /**操作结果 */
    processResult:string;
    /**派单留言 */
    assignMark:string;
    /**派单人id或者处理人Id */
    assignerID:string;
    /**派单人或者处理人 */
    assignerName:string;
}